import type { OpsTask } from "@getaways/tours";
import { api, Banner, dateTime, Empty, go, PageHead, ToggleGroup, useAsync, useStoredState } from "@getaways/extranet-ui";
import { useCan } from "../lib/access";
import { TASKS } from "../lib/labels";

/** Ops queue: what needs a person, oldest deadline first. */
export function TasksPage() {
  const can = useCan();
  const [status, setStatus] = useStoredState<"open" | "done">("tours.tasks.status", "open");
  const { data, error, reload } = useAsync(() => api<{ tasks: OpsTask[] }>("GET", `/v1/admin/tasks?status=${status}&limit=300`), [status]);
  return (
    <>
      <PageHead title="Tasks" sub="Payments due both ways, missing traveller data, refused confirmations and cancellations waiting on the supplier." />
      {error && <Banner notice={{ tone: "bad", text: error }} />}
      <div className="card" style={{ padding: 0 }}>
        <div style={{ padding: "12px 14px", borderBottom: "1px solid var(--line)" }}>
          <ToggleGroup label="Task status" value={status} onValueChange={setStatus} items={[{ value: "open", label: "Open" }, { value: "done", label: "Done" }]} />
        </div>
        {data && data.tasks.length === 0 ? <Empty>No tasks.</Empty> : (
          <table className="table">
            <thead><tr><th>Task</th><th>Kind</th><th>Due</th><th>Opened</th><th /></tr></thead>
            <tbody>
              {(data?.tasks ?? []).map((t) => (
                <tr key={t.id} className={t.bookingId ? "click" : ""} onClick={() => t.bookingId && go("bookings", t.bookingId)}>
                  <td>{t.summary}</td>
                  <td className="small">{TASKS[t.kind] ?? t.kind}</td>
                  <td className="small">{t.dueAt ? dateTime(t.dueAt) : "—"}</td>
                  <td className="small muted">{dateTime(t.createdAt)}{t.closedBy ? ` · done by ${t.closedBy}` : ""}</td>
                  <td>{status === "open" && can("booking:manage") && <button onClick={(e) => { e.stopPropagation(); void api("POST", `/v1/admin/tasks/${t.id}/done`).then(reload); }}>Done</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
